import { apiClient } from "utils/api-client";
import { createModel } from "utils/models";

export type VendorLoginEmailImageChoice = "rex_default" | "listing_image_1";

export type VendorLoginEmailSettings = {
  body_text: string | null;
  image_choice: VendorLoginEmailImageChoice;
};

export type VendorLoginEmailSettingsUpdateData =
  Partial<VendorLoginEmailSettings>;

export const vendorLoginEmailSettingsModel = createModel(
  "vendorLoginEmailSettings",
  {
    queries: {
      get: () => ({
        queryKey: [],
        queryFn: () =>
          apiClient.get<VendorLoginEmailSettings>(
            "accounts/vendor-login-email-settings",
          ),
      }),
    },
    mutations: {
      update: () => ({
        mutationKey: ["vendorLoginEmailSettings", "update"],
        mutationFn: async (data: VendorLoginEmailSettingsUpdateData) =>
          apiClient.patch<VendorLoginEmailSettings>(
            "accounts/vendor-login-email-settings",
            data,
          ),
      }),
    },
  },
);
